module.exports = __webpack_public_path__ + "img/assistant-1.0c070f8d.jpg";